<template>
  <div>
    <Form />    
    <Table/>
  </div>
</template>

<script>
  import Table from './Table'
  import Form from './Form'
  import { mapMutations } from 'vuex'
  export default {
    props: {
      tasks: null,
      types: null,
      events: null
    },
    methods: {
      ...mapMutations(['changeTaskValidations', 'changeAssignmentTypes', 'changeTypeEvents'])
    },
    components: {
      Table,
      Form
    },
    mounted () {
      if (this.tasks != null) this.changeTaskValidations(this.tasks)
      if (this.types != null) this.changeAssignmentTypes(this.types)
      if (this.events != null) this.changeTypeEvents(this.events)
    },
  }
</script>
